import { defineMessage } from 'services/localization';

export const messages = {
    titleQuoteEmailToCustomer: defineMessage('email_to_the_customer'),
    attachmentsTitleQuoteEmailToCustomer: defineMessage('attachments_for_the_customer'),
    titleSalesInvoiceEmailToCustomer: defineMessage('email_to_the_customer'),
    attachmentsTitleSalesInvoiceEmailToCustomer: defineMessage('attachments_for_the_customer'),
};
